/**
 * @generated SignedSource<<c6839c83ff73c4305eb6b8f74fa9a45c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApplyModalQuery$variables = {
  noteId: string;
  templateId: string;
};
export type ApplyModalQuery$data = {
  readonly note: {
    readonly stream?: {
      readonly template: {
        readonly id: string;
      } | null;
    };
  } | null;
  readonly template: {
    readonly author?: {
      readonly " $fragmentSpreads": FragmentRefs<"TemplateAuthor_Author">;
    } | null;
    readonly id?: string;
    readonly summary?: string;
    readonly title?: string;
  } | null;
};
export type ApplyModalQuery = {
  response: ApplyModalQuery$data;
  variables: ApplyModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "templateId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v7 = [
  (v3/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateNode",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v13 = [
  (v11/*: any*/),
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplyModalQuery",
    "selections": [
      {
        "alias": "template",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplateAuthor_Author"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteTemplateNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "note",
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApplyModalQuery",
    "selections": [
      {
        "alias": "template",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isNoteTemplateAuthor"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "Account",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "ExternalAccount",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": "fullName",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "type": "TemplateUserAuthor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "darkModeLogo",
                        "storageKey": null
                      }
                    ],
                    "type": "TemplateCompanyAuthor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": "nameThatIsOptional",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "type": "TemplateIconAuthor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteTemplateNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "note",
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bc595f10448d453db26b6e58c8470a76",
    "id": null,
    "metadata": {},
    "name": "ApplyModalQuery",
    "operationKind": "query",
    "text": "query ApplyModalQuery(\n  $templateId: ID!\n  $noteId: ID!\n) {\n  template: node(id: $templateId) {\n    __typename\n    ... on NoteTemplateNode {\n      id\n      title\n      summary\n      author {\n        __typename\n        ...TemplateAuthor_Author\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  note: node(id: $noteId) {\n    __typename\n    ... on Note {\n      stream {\n        template {\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment TemplateAuthor_Author on NoteTemplateAuthor {\n  __isNoteTemplateAuthor: __typename\n  __typename\n  ... on User {\n    id\n    fullName\n    image\n  }\n  ... on Account {\n    name\n    logo\n  }\n  ... on ExternalAccount {\n    name\n    logo\n  }\n  ... on TemplateUserAuthor {\n    image\n    fullName: name\n  }\n  ... on TemplateCompanyAuthor {\n    name\n    logo\n    darkModeLogo\n  }\n  ... on TemplateIconAuthor {\n    icon\n    color\n    nameThatIsOptional: name\n  }\n}\n"
  }
};
})();

(node as any).hash = "0374aea6aa4e202c1c22d1512e0481ce";

export default node;
